import { IChangeComboGroupPositionState } from './changeComboGroupPositionContext';
import {
	ChangeComboGroupPositionActionTypes,
	TChangeComboGroupPositionActions,
} from './changeComboGroupPositionActions';

export const changeComboGroupPositionReducer = (
	state: IChangeComboGroupPositionState,
	action: TChangeComboGroupPositionActions,
): IChangeComboGroupPositionState => {
	switch (action.type) {
		case ChangeComboGroupPositionActionTypes.SET_ID_CUSTOMER:
			return {
				...state,
				IDSelectedCustomer: action.payload.IDSelectedCustomer,
				IDSelectedRestaurant: null,
				IDSelectedDish: null,
				positionsData: [],
			};
		case ChangeComboGroupPositionActionTypes.SET_ID_RESTAURANT:
			return {
				...state,
				IDSelectedRestaurant: action.payload.IDSelectedRestaurant,
				IDSelectedDish: null,
				positionsData: [],
			};
		case ChangeComboGroupPositionActionTypes.SET_ID_DISH:
			return {
				...state,
				IDSelectedDish: action.payload.IDSelectedDish,
				positionsData: [],
			};
		case ChangeComboGroupPositionActionTypes.RESET_SELECTED_CONTROLS:
			return {
				...state,
				IDSelectedCustomer: null,
				IDSelectedRestaurant: null,
				IDSelectedDish: null,
				positionsData: [],
			};
		case ChangeComboGroupPositionActionTypes.SET_POSITIONS_DATA:
			return {
				...state,
				positionsData: action.payload.positionsData,
			};
		case ChangeComboGroupPositionActionTypes.REORDER_ITEMS:
			return {
				...state,
				positionsData: action.payload.newOrder,
			};
		case ChangeComboGroupPositionActionTypes.SET_DATA_FOR_SUBMIT:
			return {
				...state,
				dataForSubmit: action.payload.dataForSubmit,
			};
		case ChangeComboGroupPositionActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW:
			return {
				...state,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		default:
			return state;
	}
};
